import Util from "@/helper/Utility.js";

export default {
    inject: ["AccountStore"],
    computed: {
        isInitial: function () {
            return this.AccountStore.state.isInitial;
        },
        isLogin: function () {
            return this.AccountStore.state.isLogin;
        },
        profile: function () {
            return this.AccountStore.state.profile;
        },
        profileAddress: function(){
            return this.AccountStore.state.address;
        }
    },
    created: function () {
        this.AccountStore.methods.loginStatus().subscribe((status) => {
            if (!status) {
                // this.$router.replace('/welcome');
                window.location.replace("/welcome")
                return;
            }

            if (Util.isFunction(this.onAccountInit)) {
                this.onAccountInit();
            }
        });
    },
}
